var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    height: 148.6,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "-2.7 -1.2 113.7 148.6",
    width: 113.7,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4,55.6c5.3,13.2-6.8,43-9.8,57.8c-3.3,16.3,8.7,32.1,30.3,32.8c33.5,1.2,24.2-21.2,43.2-33.5 c7.4-4.8,17.8-1.2,24.1-5.6c9.6-6.6,11.2-19.1,11.7-27.1c1.1-17.5-8.9-33-11.2-49.8C96.1,10.4,92.4,0.7,62.2,0 C0.3-1.2,0.2,29.9,10.4,55.6z",
    fill: "#0e486d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBack);
export default __webpack_public_path__ + "static/media/contact-back.6b5a8edfa7c0e356b9c03fded89dc0e2.svg";
export { ForwardRef as ReactComponent };